/**
 * Sve validacije na sajtu.
 */

/** Globalna validacija. Na formu postaviti klasu vlaidate. */
$(".validate").validate();



/** Globalna validacija. Diseble-ovanje forme i dugmića nakon submit-a. */
$('.validate-form').validate({
    errorPlacement: function (error, element) {
        var el = $(element);

        if (el.hasClass('select2')) {
            el.next().addClass('error').after(error);
        } else if (el.hasClass('icheck')) {
            el.parents('.radio-group').append(error)
        } else {
            error.insertAfter(element);
        }
    },
    submitHandler: function (form) {

        $(form).find('input, textarea, select').attr('readonly', true);
        $(form).find('button').attr('disabled', true);
        form.submit();

    }
});

/** Funkcija koja se stavlja na dugmiće kada imamo više od jedne forme na stranici.
 * Kod korisnika uglavnom. */
function valid(btn) {
    var form = $(btn).parents('form');

    $(form).validate({
        errorPlacement: function (error, element) {
            var el = $(form);

            if (el.hasClass('select2')) {
                el.next().addClass('error').after(error);
            } else if (el.hasClass('icheck')) {
                el.parents('.radio-group').append(error)
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {

            $(form).find('input, textarea, select').attr('readonly', true);
            $(form).find('button').attr('disabled', true);
            form.submit();

        }
    });
}

/** Login / Prijava */
$('.login-form').validate({
    rules: {
        email: {
            required: true,
            email: true
        },
        password: {
            required: true,
            minlength: 6
        }
    }
});

/** Registracija */
$('.registration-form').validate({
    rules: {
        name: {
            required: true,
            minlength: 2
        },
        lastname: {
            required: true,
            minlength: 2
        },
        email: {
            required: true,
            email: true,
            remote: {
                url: "/email-exists"
            }
        },
        password: {
            required: true,
            minlength: 6
        },
        password_confirmation: {
            equalTo: '#password'
        }
    },
    messages: {
        email: {
            remote: 'Nalog sa ovom e-mail adresom već postoji. Probaj da se prijaviš.'
        }
    },
    errorPlacement: function (error, element) {
        console.log(error);
        console.log(element);

        if (element.hasClass('gender-field')) {
            console.log('Yes');
            error.appendTo('.gender-error')
        } else if (element.hasClass('terms-field')) {
            console.log('Yes');
            error.appendTo('.terms-error')
        } else {
            error.insertAfter(element);
        }
    },
});

/** Kontakt forma */
$('#contact-form').validate({
    submitHandler: function (form) {
        var data = $(form).serialize();
        var action = $(form).prop('action');

        $('.dsbAft').prop('disabled', true);
        $('#Send').text('Slanje u toku...');

        $.ajax({
            type: 'POST',
            url: action,
            data: data,
            success: function () {
                $(form).slideUp();
                $('.msg-sent').slideDown();
                $('.msg-not-sent').slideUp();
            },
            error: function () {
                $('#contact-form').find('input').each(function () {
                    $(this).removeProp('disabled')
                });
                $('#SenderMessage').removeProp('disabled');
                $('.msg-not-sent').slideDown();
                $('#Send').removeProp('disabled').text('Pošalji ponovo');
            }
        })
    }
});

/** PRIVREMENO SLANJE KROZ KOMENTAR */
$('#comment-form').validate({
    submitHandler: function (form) {
        var data = $(form).serialize();
        var action = $(form).prop('action');
        var btn = $(form).find('button');
        var fields = $('.dsbAft');

        fields.prop('disabled', true);
        btn.text('Slanje u toku...');

        $.post(
            action,
            data,
            function (response) {
                if (response == 1) {
                    btn.text('Pošalji');
                    fields.prop('disabled', false);
                    $(form).find('textarea').val('');
                    $(form).find('.text-success').show();
                }
            }
        );
    }
});

/** Feedback */
$('#feedback_url').val(window.location.href);
$('#feedback-form').validate({
    submitHandler: function (form) {
        var data = $(form).serialize();
        var action = $(form).prop('action');
        var btn = $(form).find('.btn-primary');
        var fields = $(form).find('input, textarea, button');

        fields.prop('disabled', true);
        btn.text('Slanje u toku...');

        $.post(
            action,
            data,
            function (response) {
                console.log(response);
                console.log(123);
                if (response == 1) {
                    btn.text('Pošalji');
                    fields.prop('disabled', false);
                    $(form).find('#feedback_subject, #feedback_message').val('');
                    $(form).find('.text-success').show();
                } else if (1 == 1) {
                    console.log(response);
                    console.log(123);
                }
            }
        );
    }
});